/**
 * FINAL VICTORY SCENE - Pantalla de Victoria Total
 * Mostrada cuando el jugador completa las 4 rondas
 */

import Phaser from "phaser";
import { SCENES, TEXTS, COLORS } from "../utils/constants.js";
import AudioManager from "../managers/AudioManager.js";

export default class FinalVictoryScene extends Phaser.Scene {
  constructor() {
    super({ key: "FinalVictoryScene" });
  }

  init(data) {
    // Recibir datos finales
    this.finalData = {
      integrity: data.integrity || 100,
      totalVotesUsed: data.totalVotesUsed || 0,
      cyclesCompleted: 4,
      bestCycle: data.bestCycle || 1,
    };
  }

  create() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    // ========================================
    // INICIALIZAR AUDIO MANAGER
    // ========================================
    this.audioManager = new AudioManager(this);
    this.audioManager.init();

    // Reproducir música épica de victoria final (final_victory.mp3)
    // Esta música NO hace loop, solo se reproduce una vez
    this.audioManager.playFinalVictoryMusic();
    console.log("🎵 Música de victoria final iniciada");

    // ========================================
    // BACKGROUND DE VICTORIA FINAL
    // ========================================
    const background = this.add.image(width / 2, height / 2, "bg_victory");

    // Escalar para cubrir toda la pantalla
    const scaleX = width / background.width;
    const scaleY = height / background.height;
    const scale = Math.max(scaleX, scaleY);
    background.setScale(scale);
    background.setDepth(-1);

    console.log("🎨 Background de victoria final cargado");

    // Overlay con gradiente dorado (semi-transparente sobre el background)
    const gradient = this.add.graphics();
    gradient.fillGradientStyle(
      parseInt("48bb78", 16),
      parseInt("48bb78", 16),
      parseInt("f6ad55", 16),
      parseInt("f6ad55", 16),
      0.4 // 40% opacidad para ver el background
    );
    gradient.fillRect(0, 0, width, height);
    gradient.setDepth(0);

    // Animación de celebración épica
    this.createEpicCelebration();

    // Título principal
    const title = this.add.text(width / 2, height * 0.12, "¡VICTORIA TOTAL!", {
      fontSize: "56px",
      fontWeight: "bold",
      color: "#ffffff",
      stroke: "#2d5016",
      strokeThickness: 8,
      fontFamily: "Arial",
    });
    title.setOrigin(0.5);

    // Animación del título
    this.tweens.add({
      targets: title,
      scale: 1.1,
      duration: 800,
      yoyo: true,
      repeat: -1,
      ease: "Sine.easeInOut",
    });

    // Ícono de trofeo/logro
    /*const trophy = this.add.text(width / 2, height * 0.25, "🏆", {
      fontSize: "75px",
    });
    trophy.setOrigin(0.5);

    // Animación del trofeo
    this.tweens.add({
      targets: trophy,
      y: trophy.y - 10,
      duration: 1000,
      yoyo: true,
      repeat: -1,
      ease: "Sine.easeInOut",
    });*/

    // Mensaje principal
    const message = this.add.text(
      width / 2,
      height * 0.36,
      "Felicidades, votando lograste defender la\n democracia a través de los años.\n\n¡Eres un verdadero arquitecto\nde la democracia!",
      {
        fontSize: "22px",
        color: "#ffffff",
        fontFamily: "Arial",
        align: "center",
        lineSpacing: 10,
        backgroundColor: "#00000044",
        padding: { x: 30, y: 20 },
      }
    );
    message.setOrigin(0.5);

    // Estadísticas finales
    this.showFinalStats(width / 2, height * 0.54);

    // Botones
    this.createPlayAgainButton(width / 2, height * 0.84);
    this.createMenuButton(width / 2, height * 0.92);

    console.log("¡VICTORIA TOTAL! - 4 ciclos completados");
  }

  /**
   * Crear efecto de celebración épica
   */
  createEpicCelebration() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    // Confeti dorado
    for (let i = 0; i < 50; i++) {
      const x = Phaser.Math.Between(0, width);
      const y = Phaser.Math.Between(-100, height);
      const size = Phaser.Math.Between(8, 20);

      const colors = [0xffd700, 0xffffff, 0x48bb78, 0xf6ad55];
      const color = colors[Phaser.Math.Between(0, colors.length - 1)];

      const particle = this.add.circle(x, y, size, color, 0.9);

      // Animación de caída
      this.tweens.add({
        targets: particle,
        y: y + height + 200,
        rotation: Phaser.Math.Between(-10, 10),
        duration: Phaser.Math.Between(3000, 6000),
        repeat: -1,
        delay: Phaser.Math.Between(0, 2000),
      });

      // Movimiento horizontal
      this.tweens.add({
        targets: particle,
        x: x + Phaser.Math.Between(-50, 50),
        duration: Phaser.Math.Between(2000, 4000),
        yoyo: true,
        repeat: -1,
        ease: "Sine.easeInOut",
      });
    }

    // Estrellas brillantes
    /*for (let i = 0; i < 20; i++) {
      const x = Phaser.Math.Between(50, width - 50);
      const y = Phaser.Math.Between(50, height - 50);

      const star = this.add.text(x, y, "⭐", {
        fontSize: "30px",
      });
      star.setOrigin(0.5);
      star.setAlpha(0);

      // Parpadeo
      this.tweens.add({
        targets: star,
        alpha: 1,
        scale: 1.5,
        duration: 500,
        yoyo: true,
        repeat: -1,
        delay: Phaser.Math.Between(0, 2000),
      });
    }*/
  }

  /**
   * Mostrar estadísticas finales
   */
  showFinalStats(x, y) {
    const stats = [
      `Ciclos completados: 4/4`,
      `Integridad final: ${Math.round(this.finalData.integrity)}%`,
      `Total de votos usados: ${this.finalData.totalVotesUsed}`,
      `Mejor ciclo: Ciclo ${this.finalData.bestCycle}`,
    ];

    const container = this.add.container(x, y);

    stats.forEach((stat, index) => {
      const statText = this.add.text(0, index * 35, stat, {
        fontSize: "18px",
        color: "#ffffff",
        fontFamily: "Arial",
        backgroundColor: "#00000066",
        padding: { x: 20, y: 8 },
      });
      statText.setOrigin(0.5, 0);
      container.add(statText);

      // Animación de entrada
      statText.setAlpha(0);
      statText.setX(-50);
      this.tweens.add({
        targets: statText,
        alpha: 1,
        x: 0,
        duration: 500,
        delay: index * 150,
        ease: "Back.easeOut",
      });
    });
  }

  /**
   * Crear botón JUGAR DE NUEVO
   */
  createPlayAgainButton(x, y) {
    const button = this.add.rectangle(x, y, 258, 48, 0x48bb78);
    button.setStrokeStyle(4, 0xffffff);
    button.setInteractive({ useHandCursor: true });

    const buttonText = this.add.text(x, y, "JUGAR DE NUEVO", {
      fontSize: "22px",
      fontWeight: "bold",
      color: "#ffffff",
      fontFamily: "Arial",
    });
    buttonText.setOrigin(0.5);

    // Efectos hover
    button.on("pointerover", () => {
      button.setFillStyle(0x5cd694);
      this.tweens.add({
        targets: [button, buttonText],
        scale: 1.1,
        duration: 100,
      });
    });

    button.on("pointerout", () => {
      button.setFillStyle(0x48bb78);
      this.tweens.add({
        targets: [button, buttonText],
        scale: 1.0,
        duration: 100,
      });
    });

    // Click - Reiniciar desde Ronda 1
    button.on("pointerdown", () => {
      this.playAgain();
    });
  }

  /**
   * Crear botón MENÚ PRINCIPAL
   */
  createMenuButton(x, y) {
    const buttonText = this.add.text(x, y, "MENÚ PRINCIPAL", {
      fontSize: "20px",
      color: "#ffffff",
      fontFamily: "Arial",
    });
    buttonText.setOrigin(0.5);
    buttonText.setInteractive({ useHandCursor: true });

    buttonText.on("pointerover", () => {
      buttonText.setColor("#ffd700");
      buttonText.setScale(1.1);
    });

    buttonText.on("pointerout", () => {
      buttonText.setColor("#ffffff");
      buttonText.setScale(1.0);
    });

    buttonText.on("pointerdown", () => {
      this.goToMenu();
    });
  }

  /**
   * Jugar de nuevo desde Ronda 1
   */
  playAgain() {
    console.log("🔄 Reiniciando juego...");

    // Limpiar localStorage
    localStorage.clear();

    // 🎵 DETENER MÚSICA AL SALIR
    if (this.audioManager) {
      this.audioManager.stopMusic();
    }

    this.cameras.main.fade(300, 0, 0, 0);

    this.time.delayedCall(300, () => {
      this.scene.start(SCENES.GAME, {
        round: 1,
        inheritedIntegrity: 100,
      });
    });
  }

  /**
   * Ir al menú principal
   */
  goToMenu() {
    console.log("🏠 Volviendo al menú...");

    // 🎵 DETENER MÚSICA AL SALIR
    if (this.audioManager) {
      this.audioManager.stopMusic();
    }

    this.cameras.main.fade(300, 0, 0, 0);

    this.time.delayedCall(300, () => {
      this.scene.start(SCENES.MENU);
    });
  }

  /**
   * Cleanup al destruir la escena
   */
  shutdown() {
    if (this.audioManager) {
      this.audioManager.destroy();
    }
  }
}
